export default{
    title:'Επιτυχία!',
    text:'Η ενέργεια ολοκληρώθηκε επιτυχώς!',
    updated: 'Οι αλλαγές αποθηκεύτηκαν επιτυχώς!',
    addedClient: 'Ο πελάτης δημιουργήθηκε επιτυχώς!',
    deleted: "Η διαγραφή ολοκληρώθηκε επιτυχώς!",
    syncStopped: 'Ο συγχρονισμός σταμάτησε επιτυχώς!',
    foodRemoved: 'Το τρόφιμο αφαιρέθηκε επιτυχώς'
}
